
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temi/[slug]/risorse",
      function () {
        return require("private-next-pages/temi/[slug]/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temi/[slug]/risorse"])
      });
    }
  